import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';

import { detectMobile } from 'features/order-tracker/utils';

import styles from './style.module.scss';

const isMobileDevice = detectMobile();

export const Tooltip: React.FC<sharedComponents.TooltipProps> = (props) => {
  const {
    tooltip: { id, title, hints, analytics },
    children,
    className = '',
  } = props;
  const tooltipRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const toggleVisibility = (): void => {
    tooltipRef.current?.classList.toggle(styles.visible);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        tooltipRef.current?.classList.remove(styles.visible);
      }
    };

    isMobileDevice && document.addEventListener('click', handleClickOutside, true);

    return () => {
      isMobileDevice && document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <button
      id={id}
      ref={buttonRef}
      onClick={isMobileDevice ? toggleVisibility : undefined}
      className={classNames(styles.container, {
        [styles.hoverable]: !isMobileDevice,
        [className]: !!className,
      })}
      type="button"
      data-analytics-hover={analytics}
    >
      {children}
      <div ref={tooltipRef} className={classNames(styles.tooltip, { [styles.shortHint]: !hints })}>
        <h6>{title}</h6>
        {!!hints &&
          hints.map(({ label, message }) => (
            <div key={label} className={styles.hintContainer}>
              <p>{label}</p>
              <p>{message}</p>
            </div>
          ))}
      </div>
    </button>
  );
};
